module.exports = __webpack_public_path__ + "media/m3.0c60d135.mp4";